export default __webpack_public_path__ + "static/media/group-12.92551f0a.svg";